/**
 * @fileoverview 로그인한 사용자가 읽지 않은 메시지에 대한 메타 데이터를 조회합니다.
 * 이 함수의 리턴값은 channelSlice의 unreadCount와 동일한 구조체입니다.
 */
import { GetUnreadCountRequest } from "@daangn/idl/rocketchat/api/api";
import { isNil } from "lodash";
import { sendRocketchatRequestWithPromise } from "~/rocketchat/rocketChatClient";

export async function getUnreadCount(socket: WebSocket) {
  const response = await sendRocketchatRequestWithPromise({
    socket,
    chatRequest: {
      name: "GetUnreadCountRequest",
      get_unread_count: GetUnreadCountRequest.create(),
    },
  });

  const unreadCount = response.get_unread_count;

  if (isNil(response.get_unread_count)) {
    throw new Error("getUnreadCount: unreadCount is nil");
  }

  return unreadCount;
}
